import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../components/AppIcon';

const TermsOfServicePage = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-white border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex items-center justify-between">
            <Link to="/" className="flex items-center space-x-3">
              <Icon name="ArrowLeft" size={24} className="text-gray-600" />
              <span className="font-poppins font-heading-semibold text-lg text-gray-900">
                Geri Dön
              </span>
            </Link>
            <h1 className="font-poppins font-heading-bold text-2xl text-gray-900">
              Kullanım Şartları
            </h1>
          </div>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="prose prose-lg max-w-none">
          <div className="mb-8">
            <p className="text-gray-600">
              <strong>Son Güncelleme:</strong> 15 Ocak 2024
            </p>
          </div>

          <section className="mb-8">
            <h2 className="font-poppins font-heading-bold text-2xl text-gray-900 mb-4">
              1. Genel Hükümler
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Bu Kullanım Şartları, Cafe Otomasyonu hizmetlerini kullanırken geçerli olan 
              kuralları ve koşulları belirler. Hizmetlerimizi kullanarak bu şartları 
              kabul etmiş sayılırsınız.
            </p>
            <p className="text-gray-700 leading-relaxed">
              Hizmetlerimiz şunları içerir: QR menü sistemi, online sipariş platformu, 
              POS sistemi, kurye takip sistemi ve yapay zeka destekli analitik araçlar.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="font-poppins font-heading-bold text-2xl text-gray-900 mb-4">
              2. Hizmet Kullanımı
            </h2>
            
            <h3 className="font-poppins font-heading-semibold text-xl text-gray-800 mb-3">
              2.1 Kayıt ve Hesap
            </h3>
            <ul className="list-disc pl-6 text-gray-700 mb-4">
              <li>Hizmetlerimizi kullanmak için geçerli bir hesap oluşturmanız gerekir</li>
              <li>Verdiğiniz bilgilerin doğru ve güncel olması sorumluluğunuzdadır</li>
              <li>Hesap güvenliğinizden siz sorumlusunuz</li>
              <li>Hesabınızı başkalarına devretmeyiniz</li>
            </ul>

            <h3 className="font-poppins font-heading-semibold text-xl text-gray-800 mb-3">
              2.2 Kullanım Kuralları
            </h3>
            <ul className="list-disc pl-6 text-gray-700">
              <li>Hizmetlerimizi yasal amaçlar için kullanın</li>
              <li>Başkalarının haklarını ihlal etmeyin</li>
              <li>Sistem güvenliğini tehdit edecek faaliyetlerde bulunmayın</li>
              <li>Hizmetlerimizi ticari amaçla kullanırken gerekli lisansları alın</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="font-poppins font-heading-bold text-2xl text-gray-900 mb-4">
              3. Fiyatlandırma ve Ödeme
            </h2>
            
            <h3 className="font-poppins font-heading-semibold text-xl text-gray-800 mb-3">
              3.1 Fiyatlandırma
            </h3>
            <ul className="list-disc pl-6 text-gray-700 mb-4">
              <li>QR menü sistemi sürekli ücretsizdir</li>
              <li>Diğer modüller için aylık/yıllık ücret alınır</li>
              <li>Fiyatlar önceden haber verilmeden değiştirilebilir</li>
              <li>Vergiler ve harçlar fiyatlara dahil değildir</li>
            </ul>

            <h3 className="font-poppins font-heading-semibold text-xl text-gray-800 mb-3">
              3.2 Ödeme Koşulları
            </h3>
            <ul className="list-disc pl-6 text-gray-700">
              <li>Ödemeler önceden yapılır</li>
              <li>Geç ödemeler için ek ücret alınabilir</li>
              <li>Ödeme yapılmaması durumunda hizmet askıya alınabilir</li>
              <li>İade politikası ayrıca belirtilmiştir</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="font-poppins font-heading-bold text-2xl text-gray-900 mb-4">
              4. Ücretsiz Deneme Süreleri
            </h2>
            <ul className="list-disc pl-6 text-gray-700">
              <li><strong>QR Menü:</strong> Sürekli ücretsiz</li>
              <li><strong>POS Sistemi:</strong> 30 gün ücretsiz deneme</li>
              <li><strong>Online Sipariş:</strong> 30 gün ücretsiz deneme</li>
              <li><strong>Kurye Takip:</strong> 30 gün ücretsiz deneme</li>
              <li><strong>Yapay Zeka:</strong> 15 gün ücretsiz deneme</li>
            </ul>
            <p className="text-gray-700 leading-relaxed mt-4">
              Deneme süresi sonunda otomatik olarak ücretli plana geçiş yapılır. 
              İptal etmek istiyorsanız deneme süresi bitmeden önce hesabınızdan iptal edin.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="font-poppins font-heading-bold text-2xl text-gray-900 mb-4">
              5. Hizmet Kalitesi ve Uptime
            </h2>
            <ul className="list-disc pl-6 text-gray-700">
              <li>Hizmetlerimiz %99.9 uptime garantisi ile sunulur</li>
              <li>Planlı bakım çalışmaları önceden duyurulur</li>
              <li>Acil durumlar için 7/24 teknik destek sağlanır</li>
              <li>Hizmet kesintileri için SLA politikamız geçerlidir</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="font-poppins font-heading-bold text-2xl text-gray-900 mb-4">
              6. Veri ve Gizlilik
            </h2>
            <ul className="list-disc pl-6 text-gray-700">
              <li>Verileriniz KVKK ve GDPR uyumlu şekilde işlenir</li>
              <li>Gizlilik politikamız ayrıca belirtilmiştir</li>
              <li>Verileriniz güvenli veri merkezlerinde saklanır</li>
              <li>Düzenli yedekleme ve felaket kurtarma planları uygulanır</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="font-poppins font-heading-bold text-2xl text-gray-900 mb-4">
              7. Sorumluluk Sınırları
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Cafe Otomasyonu olarak sorumluluklarımız:
            </p>
            <ul className="list-disc pl-6 text-gray-700 mb-4">
              <li>Hizmetlerimizi en iyi şekilde sunmak</li>
              <li>Teknik destek sağlamak</li>
              <li>Güvenlik önlemlerini almak</li>
              <li>Veri koruma standartlarını uygulamak</li>
            </ul>
            <p className="text-gray-700 leading-relaxed">
              Kullanıcılarımızın sorumlulukları:
            </p>
            <ul className="list-disc pl-6 text-gray-700">
              <li>Hizmetleri doğru şekilde kullanmak</li>
              <li>Yasal yükümlülükleri yerine getirmek</li>
              <li>Hesap güvenliğini sağlamak</li>
              <li>Ödemeleri zamanında yapmak</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="font-poppins font-heading-bold text-2xl text-gray-900 mb-4">
              8. Fikri Mülkiyet
            </h2>
            <ul className="list-disc pl-6 text-gray-700">
              <li>Tüm yazılım, tasarım ve içeriklerimiz telif hakkı ile korunur</li>
              <li>Lisans dışı kullanım yasaktır</li>
              <li>Reverse engineering ve kopyalama yasaktır</li>
              <li>Marka haklarımız korunmaktadır</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="font-poppins font-heading-bold text-2xl text-gray-900 mb-4">
              9. Hizmet Sonlandırma
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Hizmet sonlandırma durumları:
            </p>
            <ul className="list-disc pl-6 text-gray-700">
              <li>Kullanım şartlarının ihlali</li>
              <li>Ödeme yapılmaması</li>
              <li>Yasal zorunluluklar</li>
              <li>Hizmetin kullanıcı tarafından iptal edilmesi</li>
            </ul>
            <p className="text-gray-700 leading-relaxed mt-4">
              Hizmet sonlandırıldığında verileriniz 30 gün içinde silinir.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="font-poppins font-heading-bold text-2xl text-gray-900 mb-4">
              10. Uyuşmazlık Çözümü
            </h2>
            <ul className="list-disc pl-6 text-gray-700">
              <li>Uyuşmazlıklar öncelikle görüşme ile çözülmeye çalışılır</li>
              <li>Çözülemeyen durumlar için Türkiye mahkemeleri yetkilidir</li>
              <li>Türk hukuku geçerlidir</li>
              <li>Arbitraj yolu da kullanılabilir</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="font-poppins font-heading-bold text-2xl text-gray-900 mb-4">
              11. İletişim
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Kullanım şartları hakkında sorularınız için:
            </p>
            <div className="bg-gray-50 p-6 rounded-lg">
              <p className="text-gray-700">
                <strong>E-posta:</strong> info@cafeotomasyonu.com<br />
                <strong>Telefon:</strong> +90 507 588 04 81<br />
                <strong>Adres:</strong> Azmimilli Mahallesi. Şafak Sokak. No:37B. 81020, Merkez/DÜZCE
              </p>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="font-poppins font-heading-bold text-2xl text-gray-900 mb-4">
              12. Değişiklikler
            </h2>
            <p className="text-gray-700 leading-relaxed">
              Bu Kullanım Şartları zaman zaman güncellenebilir. Önemli değişiklikler 
              olduğunda sizi e-posta ile bilgilendiririz. Güncel şartlar her zaman 
              web sitemizde yayınlanır.
            </p>
          </section>
        </div>
      </main>
    </div>
  );
};

export default TermsOfServicePage; 